import { Chip, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { REWARD_TABS } from '../utils';
import StatusChip from '../../../MUI_custom_component/chips/StatusChip';


const GiftTableView = ({filteredData,selectedStatus, handleShowDetails, GiftStatusEnum, selectedTab }) => {
  return (
    <TableContainer
          component={Paper}
          sx={{ overflowX: 'auto' }}
        >
          <Table>
            <TableHead>
              <TableRow
                sx={{
                  background: '#f4f6f8',
                  borderBottom: '1px dashed #919eab33',
                }}
              >
                <TableCell
                  sx={{
                    color: '#637381',
                    fontWeight: 'bold',
                    borderBottom: 'none',
                  }}
                >
                  Beneficiary Name
                </TableCell>
                <TableCell
                  sx={{
                    color: '#637381',
                    fontWeight: 'bold',
                    borderBottom: 'none',
                  }}
                >
                  Phone
                </TableCell>
                <TableCell
                  sx={{
                    color: '#637381',
                    fontWeight: 'bold',
                    borderBottom: 'none',
                  }}
                >
                  Role
                </TableCell>
                <TableCell
                  sx={{
                    color: '#637381',
                    fontWeight: 'bold',
                    borderBottom: 'none',
                  }}
                >
                  Gift Name
                </TableCell>
                {selectedStatus !== GiftStatusEnum['ANNOUNCED'].status && (
                  <TableCell
                    sx={{
                      color: '#637381',
                      fontWeight: 'bold',
                      borderBottom: 'none',
                    }}
                  >
                    Announced Date
                  </TableCell>
                )}
                {(selectedTab === REWARD_TABS['INFLUENCER'] || selectedTab === REWARD_TABS['NETWORK_INFLUENCER']) && (
                  <TableCell
                    sx={{
                      color: '#637381',
                      fontWeight: 'bold',
                      borderBottom: 'none',
                    }}
                  >
                    Status
                  </TableCell>
                )}
                <TableCell
                  sx={{
                    color: '#637381',
                    fontWeight: 'bold',
                    borderBottom: 'none',
                  }}
                >
                  Gift Status
                </TableCell>
                
                  <TableCell
                    sx={{
                      color: '#637381',
                      fontWeight: 'bold',
                      borderBottom: 'none',
                    }}
                  >
                    Status Change Date
                  </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredData && filteredData.length > 0 ? (
                filteredData.map((gift, index) => {
                  const statusData = Object.values(GiftStatusEnum).find(
                    (s) => s.status === gift.status,
                  );
                  return (
                    <TableRow
                      key={index}
                      sx={{
                        borderBottom: '1px dashed #919eab33',
                        cursor: 'pointer',
                      }}
                      onClick={() => handleShowDetails(gift.id)}
                    >
                      <TableCell sx={{ borderBottom: 'none' }}>
                        {gift.beneficiary_name}
                      </TableCell>
                      <TableCell sx={{ borderBottom: 'none' }}>
                        {gift.beneficiary_phone}
                      </TableCell>
                      <TableCell sx={{ borderBottom: 'none' }}>
                        {gift.beneficiary_role}
                      </TableCell>
                      <TableCell sx={{ borderBottom: 'none' }}>
                        {gift.gift_product_name}
                      </TableCell>
                      
                      {selectedStatus !== GiftStatusEnum['ANNOUNCED'].status && (
                        <TableCell sx={{ borderBottom: 'none' }}>
                          {gift.announced_date || '-'}
                        </TableCell>
                      )}
                      {(selectedTab === REWARD_TABS['INFLUENCER'] || selectedTab === REWARD_TABS['NETWORK_INFLUENCER']) && (
                        <TableCell sx={{ borderBottom: 'none' }}>
                          <StatusChip type='outlined' label={gift?.verification_status} status={gift?.verification_status}  sx={{ px:0 }}/>
                        </TableCell>
                      )}
                      <TableCell sx={{ borderBottom: 'none' }}>
                        <Chip
                          label={statusData?.label}
                          sx={{
                            backgroundColor: statusData?.color,
                            color: 'white',
                            fontWeight: 'bold',
                          }}
                        />
                      </TableCell>
                      
                        <TableCell sx={{ borderBottom: 'none' }}>
                          {gift.status_change_date || '-'}
                        </TableCell>
                      
                    </TableRow>
                  );
                })
              ) : (
                <TableRow sx={{ borderBottom: '1px dashed #919eab33' }}>
                  <TableCell
                    colSpan={6}
                    align='center'
                  >
                    No data available
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
    </TableContainer>
  )
}

export default GiftTableView